module.exports = __webpack_public_path__ + "img/Position1.57cfdb00.svg";